import { useEffect, useState } from "react";
import { createUserApi } from "../../services/_user";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { getRoleListApi } from "../../services/_role";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { errorToast, successToast } from "../../components/Toast";
import { StackHolder, UserType } from "../../components/Enums";
import { formatString } from "../../components/Helper";
import { getSupplierNameListApi } from "../../services/_supplier";
import { getAllLogisticApi } from "../../services/_logistic";
import { getBuyerNameListApi } from "../../services/_buyer";
import { getAllChaApi } from "../../services/_cha";
import { getAllBrokerApi } from "../../services/_broker";
import {
  createAdminUserValidationSchema,
  createUserInitialValues,
  createStackHolderUserValidationSchema,
} from "./UserFormHelper";

const CreateUser = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const user_type = queryParams.get("user_type") || UserType.ADMIN;

  const [initialValues, setInitialValues] = useState(createUserInitialValues);
  const [validationSchema, setValidationSchema] = useState<any>();
  const [roles, setRoles] = useState([]);
  const [submitLoader, setSubmitLoader] = useState<boolean>(false);
  const [stackHolderNameList, setStackHolderNameList] = useState<any>([]);

  const getRoles = async () => {
    const result: any = await getRoleListApi(`status=true`);
    if (result?.isSuccess) {
      setRoles(result.data);
    }
  };

  const onChangeStackHolder = async (stackHolder: any) => {
    if (stackHolder === StackHolder.SUPPLIER) {
      const result: any = await getSupplierNameListApi(`status=true`);
      if (result.isSuccess) {
        setStackHolderNameList(result?.data);
      }
    }
    if (stackHolder === StackHolder.BUYER) {
      const result: any = await getBuyerNameListApi(`status=true`);
      if (result.isSuccess) {
        setStackHolderNameList(result?.data);
      }
    }
    if (stackHolder === StackHolder.CHA) {
      const result: any = await getAllChaApi(`status=true`);
      if (result.isSuccess) {
        setStackHolderNameList(result?.data);
      }
    }
    if (stackHolder === StackHolder.BROKER) {
      const result: any = await getAllBrokerApi(`status=true`);
      if (result.isSuccess) {
        setStackHolderNameList(result?.data);
      }
    }
    if (stackHolder === StackHolder.FORWARDER) {
      const result: any = await getAllLogisticApi(`status=true`);
      if (result.isSuccess) {
        setStackHolderNameList(result?.data);
      }
    }
  };

  const handleSubmit = async (values: any) => {
    setSubmitLoader(true);
    const updatedValues = {
      ...values,
      status: values.status === "true",
    };
    const result: any = await createUserApi(updatedValues);
    if (result.isSuccess) {
      setSubmitLoader(false);
      successToast(result.message);
      navigate(`/user-list?user_type=${values.user_type || UserType.ADMIN}`);
    } else {
      setSubmitLoader(false);
      errorToast(result.message);
    }
    return;
  };

  useEffect(() => {
    if (user_type === UserType.STACK_HOLDER) {
      setInitialValues({
        ...createUserInitialValues,
        user_type: UserType.STACK_HOLDER,
      });
      setValidationSchema(createStackHolderUserValidationSchema);
    } else {
      setInitialValues({
        ...createUserInitialValues,
        user_type: UserType.ADMIN,
      });
      setValidationSchema(createAdminUserValidationSchema);
      getRoles();
    }
  }, [user_type]);

  return (
    <>
      <div className="card">
        <div className="card-header pb-0">
          <div>
            <h5>Create {formatString(user_type)} User</h5>
          </div>
        </div>
        <div className="card-body">
          <Formik
            enableReinitialize={true}
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({ values, setFieldValue, handleChange, resetForm }) => {
              return (
                <Form className="dt_adv_search">
                  <div className="row">
                    <div className="col-12">
                      <div
                        className="row g-3 ms-1 mb-2"
                        style={{ padding: "10px 5px 20px 5px" }}
                      >
                        {values.user_type === UserType.ADMIN && (
                          <>
                            <div className="col-12 col-sm-6 col-lg-4">
                              <label
                                htmlFor="name"
                                className="form-label"
                                style={{ fontSize: "0.9375rem" }}
                              >
                                Name: <span className="text-danger">*</span>
                              </label>
                              <Field
                                id="name"
                                name="name"
                                type="text"
                                className="form-control"
                                placeholder="Enter name"
                                onChange={handleChange}
                              />
                              <ErrorMessage
                                name="name"
                                className="text-danger"
                                component="div"
                              />
                            </div>
                            <div className="col-12 col-sm-6 col-lg-4">
                              <label
                                htmlFor="email"
                                className="form-label"
                                style={{ fontSize: "0.9375rem" }}
                              >
                                Email: <span className="text-danger">*</span>
                              </label>
                              <Field
                                id="email"
                                name="email"
                                type="email"
                                className="form-control"
                                placeholder="Enter email"
                                onChange={handleChange}
                              />
                              <ErrorMessage
                                name="email"
                                className="text-danger"
                                component="div"
                              />
                            </div>
                            <div className="col-12 col-sm-6 col-lg-4">
                              <label
                                htmlFor="phone_no"
                                className="form-label"
                                style={{ fontSize: "0.9375rem" }}
                              >
                                Phone No:
                              </label>
                              <Field
                                id="phone_no"
                                name="phone_no"
                                type="text"
                                className="form-control"
                                placeholder="Enter phone no"
                                onChange={handleChange}
                              />
                            </div>
                            <div className="col-12 col-sm-6 col-lg-4">
                              <label
                                htmlFor="password_2"
                                className="form-label"
                                style={{ fontSize: "0.9375rem" }}
                              >
                                Password: <span className="text-danger">*</span>
                              </label>
                              <Field
                                id="password_2"
                                name="password"
                                type="password"
                                className="form-control"
                                placeholder="Enter password"
                                onChange={handleChange}
                              />
                              <ErrorMessage
                                name="password"
                                className="text-danger"
                                component="div"
                              />
                            </div>
                            <div className="col-12 col-sm-6 col-lg-4">
                              <label
                                htmlFor="role_id"
                                className="form-label"
                                style={{ fontSize: "0.9375rem" }}
                              >
                                Role: <span className="text-danger">*</span>
                              </label>
                              <select
                                id="role_id"
                                name="role_id"
                                className="form-select"
                                onChange={handleChange}
                              >
                                <option value="">Select Role</option>
                                {roles?.length &&
                                  roles.map((role: any) => (
                                    <option key={role.id} value={role.id}>
                                      {role.name}
                                    </option>
                                  ))}
                              </select>
                              <ErrorMessage
                                name="role_id"
                                className="text-danger"
                                component="div"
                              />
                            </div>
                            <div className="col-12 col-sm-6 col-lg-4">
                              <label
                                htmlFor="status"
                                className="form-label"
                                style={{ fontSize: "0.9375rem" }}
                              >
                                Status: <span className="text-danger">*</span>
                              </label>
                              <select
                                id="status"
                                name="status"
                                className="form-select"
                                onChange={handleChange}
                              >
                                <option value="">Select Status</option>
                                <option value="true">Active</option>
                                <option value="false">Inactive</option>
                              </select>
                              <ErrorMessage
                                name="status"
                                className="text-danger"
                                component="div"
                              />
                            </div>
                            <div className="col-12">
                              <button
                                type="submit"
                                className="btn btn-primary"
                                disabled={submitLoader}
                              >
                                {submitLoader && (
                                  <span
                                    className="spinner-border spinner-border-sm me-2"
                                    role="status"
                                    aria-hidden="true"
                                  ></span>
                                )}
                                Submit
                              </button>
                              <Link
                                to={"/user-list"}
                                type="button"
                                className="btn btn-label-github ms-5"
                              >
                                Back
                              </Link>
                            </div>
                          </>
                        )}

                        {values.user_type === UserType.STACK_HOLDER && (
                          <>
                            <div className="col-12 col-sm-6 col-lg-4">
                              <label
                                htmlFor="stack_holder_type"
                                className="form-label"
                                style={{ fontSize: "0.9375rem" }}
                              >
                                Stack Holder Type:{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <select
                                name="stack_holder_type"
                                id="stack_holder_type"
                                className="form-select"
                                value={values.stack_holder_type}
                                onChange={(e) => {
                                  resetForm({
                                    values: {
                                      ...createUserInitialValues,
                                      user_type: values.user_type,
                                    },
                                  });
                                  setFieldValue(e.target.name, e.target.value);
                                  onChangeStackHolder(e.target.value);
                                }}
                              >
                                <option value="">Select Stack Holder:</option>
                                {Object.values(StackHolder).map((type) => {
                                  return (
                                    <option value={type} key={type}>
                                      {formatString(type)}
                                    </option>
                                  );
                                })}
                              </select>
                              <ErrorMessage
                                name="stack_holder_type"
                                className="text-danger"
                                component="div"
                              />
                            </div>
                            <div className="col-12 col-sm-6 col-lg-4">
                              <label
                                htmlFor="stackHolderSelect"
                                className="form-label"
                                style={{ fontSize: "0.9375rem" }}
                              >
                                Stack holder Name:{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <select
                                name="stack_holder_id"
                                id="stack_holder_id"
                                className="form-select"
                                value={values.stack_holder_id}
                                onChange={(e) => {
                                  handleChange(e);
                                  const stackHolderDetails =
                                    stackHolderNameList.find(
                                      (s: any) => s.id === e.target.value
                                    );
                                  setFieldValue(
                                    "name",
                                    stackHolderDetails?.name || ""
                                  );
                                  setFieldValue(
                                    "email",
                                    stackHolderDetails?.email || ""
                                  );
                                  setFieldValue(
                                    "phone_no",
                                    stackHolderDetails?.phone_no || ""
                                  );
                                }}
                              >
                                <option value="">
                                  Select Stack Holder Name:
                                </option>
                                {stackHolderNameList.map((stackHolder: any) => {
                                  return (
                                    <option
                                      value={stackHolder.id}
                                      key={stackHolder.name}
                                    >
                                      {formatString(stackHolder.name)}
                                    </option>
                                  );
                                })}
                              </select>
                              <ErrorMessage
                                name="stack_holder_id"
                                className="text-danger"
                                component="div"
                              />
                            </div>
                            <div className="col-12 col-sm-6 col-lg-4">
                              <label
                                htmlFor="email"
                                className="form-label"
                                style={{ fontSize: "0.9375rem" }}
                              >
                                Email: <span className="text-danger">*</span>
                              </label>
                              <Field
                                id="email"
                                name="email"
                                type="email"
                                className="form-control"
                                placeholder="Enter email"
                                onChange={handleChange}
                                disabled
                              />
                              <ErrorMessage
                                name="email"
                                className="text-danger"
                                component="div"
                              />
                            </div>
                            <div className="col-12 col-sm-6 col-lg-4">
                              <label
                                htmlFor="phone_no"
                                className="form-label"
                                style={{ fontSize: "0.9375rem" }}
                              >
                                Phone No:
                              </label>
                              <Field
                                id="phone_no"
                                name="phone_no"
                                type="text"
                                className="form-control"
                                placeholder="Enter phone no"
                                onChange={handleChange}
                                disabled
                              />
                            </div>
                            <div className="col-12 col-sm-6 col-lg-4">
                              <label
                                htmlFor="password_2"
                                className="form-label"
                                style={{ fontSize: "0.9375rem" }}
                              >
                                Password: <span className="text-danger">*</span>
                              </label>
                              <Field
                                id="password_2"
                                name="password"
                                type="password"
                                className="form-control"
                                placeholder="Enter password"
                                onChange={handleChange}
                              />
                              <ErrorMessage
                                name="password"
                                className="text-danger"
                                component="div"
                              />
                            </div>
                            <div className="col-12 col-sm-6 col-lg-4">
                              <label
                                htmlFor="status"
                                className="form-label"
                                style={{ fontSize: "0.9375rem" }}
                              >
                                Status: <span className="text-danger">*</span>
                              </label>
                              <select
                                id="status"
                                name="status"
                                className="form-select"
                                onChange={handleChange}
                              >
                                <option value="">Select Status</option>
                                <option value="true">Active</option>
                                <option value="false">Inactive</option>
                              </select>
                              <ErrorMessage
                                name="status"
                                className="text-danger"
                                component="div"
                              />
                            </div>
                            <div className="col-12">
                              <button
                                type="submit"
                                className="btn btn-primary"
                                disabled={submitLoader}
                              >
                                {submitLoader && (
                                  <span
                                    className="spinner-border spinner-border-sm me-2"
                                    role="status"
                                    aria-hidden="true"
                                  ></span>
                                )}
                                Submit
                              </button>
                              <Link
                                to={`/user-list?user_type=${UserType.STACK_HOLDER}`}
                                type="button"
                                className="btn btn-label-github ms-5"
                              >
                                Back
                              </Link>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </Form>
              );
            }}
          </Formik>
        </div>
      </div>
    </>
  );
};

export default CreateUser;
